import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/home/HomePageClient.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/skeletons/HomeSkeleton.jsx");
